(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('consumption', {
            parent: 'pay-orderNew',
            url: '/consumption?page&sort&startTime&endTime&classType',
            data: {
                authorities: ["ROLE_BILLING_DETAIL"],
                pageTitle: 'global.menu.entities.consumptionList'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/consumption/consumption.html',
                    controller: 'ConsumptionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null,
                startTime: null,
                endTime: null,
                classType: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        startTime: $stateParams.startTime,
                        endTime: $stateParams.endTime,
                        classType: $stateParams.classType,
                        
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productPurchase');
                     $translatePartialLoader.addPart('purchaseStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
